import React from 'react'
import ActiveProductionOrdersIndex from '../features/activeProductionOrders'
function ActiveProductionOrdersPage() {
  return (
    <ActiveProductionOrdersIndex />
  )
}

export default ActiveProductionOrdersPage